const capitalizeFirstLetter = ( val: string | undefined ) => ( val
    ? String( val ).charAt( 0 ).
        toUpperCase() + String( val ).slice( 1 ).
        toLowerCase()
    : val );

const normalizeStopLabel = ( value: string | undefined | null ): string | undefined => {
    if ( value == null ) {
        return undefined;
    }

    const trimmedValue = value.trim();
    if ( trimmedValue.length === 0 ) {
        return undefined;
    }

    const upperValue = trimmedValue.toUpperCase();
    if ( upperValue === "START" ) {
        return "Départ";
    }
    if ( upperValue === "END" ) {
        return "Arrivée";
    }

    return trimmedValue;
};

export { capitalizeFirstLetter, normalizeStopLabel };
